// The Azure Functions isolated worker does not reliably surface the standard
// User-Agent header to the backend, so we forward the browser's user agent in a
// custom header. The server reads this (falling back from User-Agent) to detect
// the device type and operating system.
export function clientUserAgentHeaders(): Record<string, string> {
  if (typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && navigator.userAgent.length > 0) {
    return { 'X-Client-User-Agent': navigator.userAgent };
  }
  return {};
}
